import { defineStore } from 'pinia';
import { getDictionary } from '@/api/core';

export const useDictionaryStore = defineStore('dictionary', {
  state: () => ({
    dictionary: {},
  }),
  actions: {
    async init() {
      // const response = await getDictionary();
      // if (response.status === 200) {
      //   this.setDictionary(response.data);
      // }
    },
    setDictionary(dictionary) {
      this.dictionary = dictionary;
    },
    clear() {
      this.dictionary = {};
    }
  }
});
